import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {AppMainComponent} from './app.main.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppErrorComponent} from './pages/app.error.component';
import {AppAccessdeniedComponent} from './pages/app.accessdenied.component';
import { HistoryComponent } from './Modules/Components/History/history.component';
import { ScheduleComponent } from './Modules/Components/schedule/schedule.component';
import { LoginComponent } from './modules/Components/login/login.component';
import { ForgetpasswordComponent } from './modules/Components/forgetpassword/forgetpassword.component';
import { ChangepasswordComponent } from './modules/Components/changepassword/changepassword.component';
import { PatientCodeVerificationComponent } from './modules/Components/patientcodeverification/patientcodeverification.component';
import { LoginAuthenticationGuard } from './core/guards/login-authentication.guard';
import { PatientResultComponent } from './modules/Components/patientResult/patientResult.component';
import { ServiceInstructionComponent } from './modules/Components/serviceInstruction/serviceInstruction.component';
import { PatCodeRegisterationComponent } from './Modules/Components/pat-code-registeration/pat-code-registeration.component';
import { PatcodeUrlRegisterationGuard } from './core/guards/patcode-url-registeration.guard';
import { DoctorScheduleComponent } from './Modules/Components/doctor-schedule/doctor-schedule.component';
import { RequestComponent } from './Modules/Components/request/request.component';
import { SpecialtyComponent } from './Modules/Components/specialty/specialty.component';
import { CategoryComponent } from './Modules/Components/category/category.component';
import { ClinicdoctorComponent } from './Modules/Components/clinicdoctor/clinicdoctor.component';
import { RequestDetailsComponent } from './Modules/Components/request-details/request-details.component';
import { PaymentComponent } from './Modules/Components/payment/payment.component';
import { PaymentSuccessComponent } from './Modules/Components/payment-success/payment-success.component';
import { PaymentFailComponent } from './Modules/Components/payment-fail/payment-fail.component';
import { RegisterComponent } from './Modules/Components/register/register.component';
import { CustomRegisterationComponent } from './Modules/Components/custom-registeration/custom-registeration.component';
import { CustomLoginComponent } from './Modules/Components/custom-login/custom-login.component';
import { CustomForgetPasswordComponent } from './Modules/Components/custom-forget-password/custom-forget-password.component';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {path:'',pathMatch:'full',redirectTo:'login' },
            {
                path: '', component: AppMainComponent,
                children: [
                    {path:'',pathMatch:'full',redirectTo:'schedule' },
                    {path:'schedule',canActivate:[LoginAuthenticationGuard], component: ScheduleComponent},
                    {path:'newrequest',canActivate:[LoginAuthenticationGuard], component: RequestComponent,
                      children:[
                        {path:'category',canActivate:[LoginAuthenticationGuard], component: CategoryComponent},
                        {path:'specialty',canActivate:[LoginAuthenticationGuard], component: SpecialtyComponent},
                        {path:'clinicdoctor',canActivate:[LoginAuthenticationGuard], component: ClinicdoctorComponent},
                        {path:'requestdetails',canActivate:[LoginAuthenticationGuard], component: RequestDetailsComponent},
                        {path:'confirmpayment',canActivate:[LoginAuthenticationGuard], component: PaymentComponent}
                    ]},
                    {path: 'history',canActivate:[LoginAuthenticationGuard], component: HistoryComponent},
                    {path:'changepassword',canActivate:[LoginAuthenticationGuard], component:ChangepasswordComponent}
                ]
            },            
            {path:'portalauth',canActivate:[LoginAuthenticationGuard , PatcodeUrlRegisterationGuard],component:PatCodeRegisterationComponent},
            {path: 'patientcodeverification', component: PatientCodeVerificationComponent},
            {
                path:'forgetpassword',
                pathMatch : 'full',
                component:ForgetpasswordComponent
            },
            {
                path:'report/visitreports',
                pathMatch : 'full',
                component: PatientResultComponent
            },
            {
                path:'report/getserviceinstructionsview',
                pathMatch : 'full',
                component: ServiceInstructionComponent
            },
            {
                path:'doctorappointments',
                pathMatch : 'full',
                component: DoctorScheduleComponent
            },
            {path: 'login',canActivate:[LoginAuthenticationGuard],component: LoginComponent, pathMatch : 'full'},            
            {path: 'register',canActivate:[LoginAuthenticationGuard],component: RegisterComponent, pathMatch : 'full'},            
            {path: 'customregister',component: CustomRegisterationComponent, pathMatch : 'full'},            
            {path: 'customlogin',component: CustomLoginComponent, pathMatch : 'full'},            
            {path: 'customforgetpassword',component: CustomForgetPasswordComponent, pathMatch : 'full'},            
            {path: 'error', component: AppErrorComponent},
            {path: 'paymentsuccess', component: PaymentSuccessComponent},
            {path: 'paymentfail', component: PaymentFailComponent},
            {path: 'accessdenied', component: AppAccessdeniedComponent},
            {path: '404', component: AppNotfoundComponent},
            {path: '**', component: AppNotfoundComponent},
        ], {scrollPositionRestoration: 'enabled',anchorScrolling:'enabled'})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
